import React, { useCallback, useRef, useState } from 'react';
import { ChevronLeftIcon, HardHatIcon } from 'lucide-react';
import { LatestProjectsDrawer } from './LatestProjectsDrawer';

/** Fixed "Latest Projects" edge tab plus its slide-out drawer. */
export function LatestProjectsWidget() {
  const [open, setOpen] = useState(false);
  const tabRef = useRef<HTMLButtonElement>(null);
  const close = useCallback(() => {
    setOpen(false);
    window.setTimeout(() => tabRef.current?.focus({
      preventScroll: true
    }), 0);
  }, []);
  return <>
      <button ref={tabRef} type="button" onClick={() => setOpen(true)} aria-haspopup="dialog" aria-expanded={open} aria-controls="latest-projects-drawer" className={`group fixed bottom-5 right-0 z-[35] flex translate-x-1.5 items-center gap-2 bg-brand-action py-3 pl-4 pr-5 text-white shadow-[0_10px_28px_rgba(0,0,0,0.4)] transition-[transform,background-color,opacity] duration-200 ease-out hover:translate-x-0 hover:bg-brand-action-hover focus-visible:translate-x-0 focus-visible:outline-white md:bottom-auto md:top-[58%] md:-translate-y-1/2 md:flex-col md:gap-3 md:px-3 md:pb-5 md:pr-[18px] md:pt-4 ${open ? 'pointer-events-none opacity-0' : ''}`} data-id="element-313" data-mp="hnjayuhchscb">
        <HardHatIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-314" data-mp="1yz3kbdo44222" />
        <span className="whitespace-nowrap font-display text-[14px] font-bold uppercase tracking-[0.16em] md:rotate-180 md:text-[15px] md:[writing-mode:vertical-rl]" data-id="element-315" data-mp="1u4z6qbkccvs0">
          Latest Projects
        </span>
        <ChevronLeftIcon className="h-4 w-4 shrink-0 transition-transform duration-200 ease-out group-hover:-translate-x-0.5" aria-hidden="true" data-id="element-316" data-mp="23w3qdokyp4t6" />
      </button>
      <LatestProjectsDrawer open={open} onClose={close} data-id="element-317" data-mp="2dv192avpi449" />
    </>;
}